import { Box, InputBase, Typography } from "@mui/material"
import { useTranslation } from "react-i18next";
import { toEnglishDate } from "../../helpers/dateFormat";

export const DateInput = ({ name, isDisabled = false, title, handleInputChange, required = false, hasMin = false }) => {

    const { t } = useTranslation('global');
    const date = new Date();
    const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
    const actualDate = date.toLocaleDateString("es-ES", options);

    return (
        <Box minWidth='calc(50% - 8px)'>
            <Typography variant='overline' color='secondary'>{t(`date.${title}`)}</Typography>
            <InputBase
                fullWidth
                name={title}
                size="small"
                variant="standard"
                value={name || ''}
                disabled={isDisabled}
                onChange={handleInputChange}
                required={required}
                inputProps={hasMin &&{ min:toEnglishDate(actualDate)}}
                type='date'
            />
        </Box>
    )
}